import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { signInModule } from './modules/singIn';
import { scaffolderModule } from './modules/scaffolder';
import { catalogModule } from './modules/catalog';
import { migrationCatalogModule, migrationModule } from './modules/migration';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    signInModule,
    scaffolderModule,
    catalogModule,
    migrationModule,
    migrationCatalogModule,
  ],
});
